import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class Footer extends Component {
  render() {
    const { t } = this.props;
    return (
      <footer class="g-bg-main-light-v1">
        <div class="container g-pt-15 g-pb-10">
          <div class="row">
            <div class="col-md-8 text-center text-md-left align-self-center">
              <div class="d-lg-flex align-items-start">
                <div class="d-flex justify-content-center text-nowrap">
                  <span class="g-font-size-14 g-color-gray-dark-v5">
                    2019 &copy; mimiMaps
                  </span>
                </div>

                <div class="d-flex justify-content-center text-nowrap">
                  <span class="g-color-gray-dark-v5 d-none d-lg-block g-mx-10">
                    |
                  </span>
                  <span>
                    <a
                      class="u-link-v5 g-color-gray-dark-v5 g-color-white--hover"
                      href="mailto:info@mimimaps.com.ua"
                    >
                      <i class="fa fa-envelope-o g-mr-5" aria-hidden="true"></i>
                      info@mimimaps.com.ua
                    </a>
                    <br />
                    <a
                      class="
                      u-link-v5
                      g-color-gray-dark-v5
                      g-color-white--hover
                    "
                      href="tel:+380665444363"
                    >
                      <i class="fa fa-phone g-mr-5" aria-hidden="true"></i>
                      +380665444363
                    </a>
                  </span>
                </div>

                <div>
                  <div class="d-flex justify-content-center text-nowrap">
                    <span class="g-color-gray-dark-v5 d-none d-lg-block g-mx-10">
                      |
                    </span>
                    <span class="g-color-gray-dark-v5 text-center text-lg-left">
                      Пн-Пт: 11:00 – 19:00
                      <br />
                    </span>
                  </div>
                </div>
                <div>
                  <div class="d-flex justify-content-center text-nowrap">
                    <span class="g-color-gray-dark-v5 d-none d-lg-block g-mx-10">
                      |
                    </span>
                    <span>
                      <a
                        class="
                          u-link-v5
                          g-color-gray-dark-v5
                          g-color-white--hover
                        "
                        href="/oferta.html"
                      >
                        {t("Договір оферти")}
                      </a>
                      <br />
                      <a
                        class="
                          u-link-v5
                          g-color-gray-dark-v5
                          g-color-white--hover
                        "
                        href="/return.html"
                      >
                        {t("Обмін та повернення")}
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 align-self-center">
              <ul class="list-inline text-center text-md-right mb-0">
                <li
                  class="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Facebook"
                >
                  <a
                    href="https://www.facebook.com/mimimapsua"
                    target="_blank"
                    class="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>
                <li
                  class="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Instagram"
                >
                  <a
                    href="https://www.instagram.com/mimimapsua"
                    target="_blank"
                    class="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <i class="fa fa-instagram"></i>
                  </a>
                </li>
                <li
                  class="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Viber"
                >
                  <a
                    href="viber://chat?number=380665444363"
                    target="_blank"
                    class="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/img/viber-logo-grey-vector.svg"
                      }
                      style={{ height: "48px" }}
                    />
                  </a>
                </li>
                <li
                  class="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Telegram"
                >
                  <a
                    href="https://t.me/mimimapsua"
                    target="_blank"
                    class="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <i class="fa fa-telegram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default withTranslation()(Footer);
